<template>
  <div>
    <!-- 社区管理员 -->
    <div class="admin">
      <div class="admin-title">
        <img class="admin-icon" src="@/assets/images/partyDetail/org-admin-icon.png">
        <span class="admin-text">物委会主任</span>
        <img class="admin-icon" src="@/assets/images/partyDetail/org-admin-icon.png">
      </div>

      <div class="member-list" v-if="manager.length">
        <div class="admin-person member-person" v-for="(item,index) in manager" :key="item.id">
          <div class="person-avatar-wrapper" @mouseenter="selectMangerIndex = index" @mouseleave="selectMangerIndex = 99">
            <img v-if="item.headPicUrl" class="person-avatar" :src="item.headPicUrl">
            <img v-else class="person-avatar" src="../../../assets/images/default.png"/>
            <div v-if="selectMangerIndex == index" class="person-avatar-icons" style="justify-content: center">
              <!--<div  class="iconfont icon-qiandao" @click="onAddManager(index)"></div>-->
              <div  class="iconfont icon-delete" @click="delManager(index)">
              </div>
            </div>
          </div>
          <div class="person-name">{{item.realName}}</div>
        </div>
      </div>


      <div class="zhanwei" v-else>请选择物委会主任</div>

      <Button v-if="!manager.unionId && manager.length < 1" class="add-manager" @click="onAddManager" type="warning">添加物委会主任</Button>
      <add-manager :oldshowManager="showManager" @quxiao="quxiao" @addManagerSuccess="addManagerSuccess" :passManager="manager" :name="'committee'"></add-manager>
    </div>
    <!-- 社区委员 -->
    <div class="member">
      <div class="admin-title">
        <img class="admin-icon" src="@/assets/images/partyDetail/org-admin-icon.png">
        <span class="admin-text">物委会成员</span>
        <img class="admin-icon" src="@/assets/images/partyDetail/org-admin-icon.png">
      </div>
      <div class="member-list" v-if="leader.length > 0">
        <div class="admin-person member-person" v-for="(item,index) in leader" :key="item.id">
          <div class="person-avatar-wrapper" @mouseenter="selectLeadIndex = index" @mouseleave="selectLeadIndex = 99">
            <img v-if="item.headPicUrl" class="person-avatar" :src="item.headPicUrl">
            <img v-else class="person-avatar" src="../../../assets/images/default.png"/>
            <div v-if="selectLeadIndex == index" class="person-avatar-icons">
              <div  class="iconfont icon-qiandao" @click="changeAddMember(index)"></div>
              <div  class="iconfont icon-delete" @click="delMember(index)">
              </div>
            </div>
          </div>
          <div class="person-name">{{item.realName}}</div>
          <div class="person-job">{{item.proTitle}}</div>
        </div>
      </div>
      <div class="zhanwei" v-else>请选择物委会成员</div>
      <Button class="add-member" @click="onAddMember" type="warning">添加物委会成员</Button>
      <add-member :showModal="showModal" :passLeader="passLeader" :name="'committee'" @quxiao="quxiao" @addMember="addMember"></add-member>
    </div>
  </div>
</template>

<script>
  import addMember from "./addMember";
  import addManager from './addManager'
  export default {
    components: { addMember, addManager },
    props: ["manager", "leader"],
    data() {
      return {
        showModal: false,
        showManager:false,
        showShanchu:false,
        selectLeadIndex:99,
        selectMangerIndex:99,
        passLeader:'',
        memberIndex:'',//选择的负责人的索引值 ，用来更新修改信息
      };
    },
    methods: {
      addMember(person) {
        this.showModal = false
        this.$emit("addMember", {person,index:this.memberIndex});
      },
      delMember(index) {
        let url = this.urlobj.delLeader(this.leader[index].id);
        this.$store.commit("updateSpinShow", true);
        this.$delete(url)
          .then(res => {
            this.$store.commit("updateSpinShow", false);
            if (res.isSucceed) {
              this.$Message.success("删除成功");
              this.$emit("delMember", index);
            }
          })
          .catch(e => console.log(e));
      },
      //删除管理员
      delManager (index) {
        var that = this
        var url = this.urlobj.delAdmin();
        this.$store.commit("updateSpinShow", true);
        that
          .$post(url, {
            unionId: that.manager[index].unionId,
            zoneIdList: [sessionStorage.zoneId]
          }).then(res => {
          this.$store.commit("updateSpinShow", false);
          that.$Message.success('删除成功')
          that.$emit('delManager',index)
        })
      },
      // 显示添加负责人对话框
      onAddMember() {
        this.passLeader = ''
        this.showModal = true;
      },
      changeAddMember (index) {
        this.memberIndex = index
        this.passLeader = this.leader[index]
        console.log("passLeader",this.passLeader)
        this.showModal = true;
      },

      onAddManager () {
        this.showManager = true
      },
      modalCancel() {
        this.showModal = false;
      },
      //添加管理员弹窗的取消
      quxiao () {
        this.showManager = false
        this.showModal = false
      },
      addManagerSuccess (data) {
        this.showManager = false
        this.$emit('addManagerSuccess',data)
      },
    }
  };
</script>
<style lang="less" scoped>
  /* 支部管理员 */
  .admin {
    position: relative;
    padding-bottom: 50px;
  }
  .admin-title {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 50px;
    margin-bottom: 30px;
  }
  .admin-icon {
    height: 32px;
    width: 60px;
  }
  .admin-icon:last-child {
    transform: rotateY(180deg);
  }
  .admin-text {
    font-size: 30px;
    color: #4b4b4b;
    font-weight: bolder;
    margin: 0 10px;
  }
  .admin-person {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  /*img[src=""].person-avatar {*/
  /*visibility: hidden;*/
  /*}*/
  .person-avatar-wrapper{
    width: 120px;
    height: 120px;
    border-radius: 100%;
    position: relative;
  }
  .person-avatar-icons{
    width: 120px;
    height: 120px;
    border-radius: 100%;
    position: absolute;
    top:0;
    background: rgba(0,0,0,0.5);
    color:#fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding:0 5px;
  }
  .person-avatar-icons .iconfont{
    font-size: 45px;
  }
  .person-avatar {
    width: 120px;
    height: 120px;
    border-radius: 100%;
    box-shadow: 2px 2px 4px 1px #898989;
  }
  .person-name {
    font-size: 22px;
    color: #4b4b4b;
    margin-top: 10px;
  }
  .add-manager{
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 0;
  }
  /* 委员 */
  .member {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  }
  // 委员列表
  .member-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
  }
  // 委员 单元
  .member-person {
    position: relative;
    margin: 0 50px;
    &:hover .del-img {
      display: block;
    }
  }
  // 委员删除按钮
  .del-img {
    display: none;
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(50%, -50%);
    transition: all 0.3s ease-in-out;
    &:hover {
      color: #cc0001;
    }
  }
  .person-job {
    font-size: 16px;
    color: #999;
  }
  /* 添加负责人按钮 */
  .add-member {
    margin-top: 20px;
  }
  .hengxian{
    width: 150px;
    height:0px;
    border-bottom:1px solid #000
  }
  .zhanwei{
    text-align: center;
    color:#666;
    font-size:27px;
  }
  .admin-icon {
    height: 32px;
    width: 60px;
  }
  .admin-icon:last-child {
    transform: rotateY(180deg);
  }
</style>

